import { Box, Button, Notify, Text } from "@flexisaf/flexibull2";
import { useRef, useState } from "react";
import { Cropper } from "react-advanced-cropper";
import "react-advanced-cropper/dist/style.css";
import styled from "styled-components";
import Placeholder from "./placeholder";
import Theme from "../../theme";

const Wrapper = styled.div`
  width: ${(props) => (props.size ? props.size : "300px")};
  height: ${(props) => (props.size ? props.size : "300px")};
  position: relative;
  /* border-radius: ${Theme.SecondaryRadius}; */
  border-radius: 8px;
  border: 1px solid ${Theme.PrimaryBorderColor};

  &::after {
    content: "";
    position: absolute;
  }
  & img {
    width: ${(props) => (props.size ? props.size : "300px")};
    border-radius: 8px;
  }

  & .cropper {
    background-color: #fafafa;
    border-radius: 8px;
    height: ${(props) => (props.size ? props.size : "300px")};
  }

  & .buttons-wrapper {
    position: absolute;
    bottom: 0px;
    right: 0px;

    & .button {
      border: none;
      /* color: ${Theme.PrimaryFontColor}; */
      cursor: pointer;
      width: ${(props) => (props.size ? props.size : "298px")};
      border-radius: 0 0 8px 8px;
      padding: 15px 0;

      & input {
        display: none;
      }
    }
  }
`;

function urlToFile(url, filename, mimeType) {
  return fetch(url)
    .then((res) => res.arrayBuffer())
    .then(
      (buf) =>
        new File([buf], filename + mimeType.replace("image/", "."), {
          type: mimeType,
        })
    );
}

function base64Mime(encoded) {
  let result = "";
  if (typeof encoded !== "string") {
    return result;
  }
  const mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
  if (mime && mime.length) {
    result = mime[1];
  }
  return result;
}

export const MyCropper = (props, ref) => {
  const cropperRef = useRef(null);
  const inputRef = useRef(null);
  const [image, setImage] = useState(null);
  const [uploaded, setUploaded] = useState(false);
  const [fileTooBig, setFileTooBig] = useState(false);
  const [showCropper, setShowCropper] = useState(true);

  const onOpenExplorer = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const onHandleUpload = () => {
    const canvas = cropperRef.current?.getCanvas();
    console.log({ canvas });

    if (canvas) {
      const croppedData = canvas.toDataURL();

      const mimeType = base64Mime(croppedData);
      urlToFile(croppedData, props.imageName, mimeType).then((file) => {
        props?.onUpload(file);
        setUploaded(true);
        setShowCropper(false);
      });
    }
  };

  const onLoadImage = (event) => {
    // Reference to the DOM input element
    const { files } = event.target;

    // Ensure that you have a file before attempting to read it
    if (files && files[0]) {
      // Create the blob link to the file to optimize performance:
      const blob = URL.createObjectURL(files[0]);

      // Get the image type from the extension. It's the simplest way, though be careful it can lead to an incorrect result:
      setImage({
        src: blob,
        type: files[0].type,
      });

      if (files[0].size > 1024 * (1024 * 1)) {
        Notify("File is too big, file must be less than 1mb", {
          position: "top-right",
          status: "warning",
        });
        setImage(null);
        setFileTooBig(true);
      }
    }
    // Clear the event target value to give the possibility to upload the same image:
    event.target.value = "";
  };

  return (
    <Wrapper {...props}>
      {showCropper ? (
        <Cropper
          src={image && image.src}
          ref={cropperRef}
          className={"cropper"}
        />
      ) : (
        <img src={image && image.src} alt="" />
      )}

      {image !== null ? null : (
        <Box style={{ position: "absolute", top: "35%", right: "40%" }}>
          <Text block color={Theme.PrimaryGrey} size={Theme.H1}>
            {" "}
            <Placeholder />
          </Text>
        </Box>
      )}
      <div className="buttons-wrapper">
        {!uploaded && (
          <Button
            className="button"
            onClick={
              image !== null && fileTooBig === false
                ? onHandleUpload
                : image === null || fileTooBig === true
                ? onOpenExplorer
                : onOpenExplorer
            }
            color={Theme.PrimaryColor}
            fontColor="#fff"
            style={{ borderRadius: "0 0 8px 8px" }}
            progress={props.loading}
            disabled={props.loading}
          >
            <input
              ref={inputRef}
              type="file"
              accept="image/*"
              onChange={onLoadImage}
            />
            {image !== null && fileTooBig === false
              ? `${uploaded ? "Upload Complete" : "Upload file"}`
              : image === null || fileTooBig === true
              ? "Browse file"
              : "Browse file"}
          </Button>
        )}
      </div>
    </Wrapper>
  );
};
